/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function WorkorderDenyCommandFromJSON(json) {
    return WorkorderDenyCommandFromJSONTyped(json, false);
}
export function WorkorderDenyCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'denyReason': !exists(json, 'denyReason') ? undefined : json['denyReason'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'denyDateTime': !exists(json, 'denyDateTime') ? undefined : (json['denyDateTime'] === null ? null : new Date(json['denyDateTime'])),
    };
}
export function WorkorderDenyCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'denyReason': value.denyReason,
        'user': UserToJSON(value.user),
        'denyDateTime': value.denyDateTime === undefined ? undefined : (value.denyDateTime === null ? null : value.denyDateTime.toISOString()),
    };
}
